import React from "react";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2,
  BODY_SM,
  CARD_TITLE,
} from "./sections";

const REASONS = [
  {
    title: "Prompts are longer than search queries",
    body: "A Google search might be three words. A good ChatGPT prompt is often three sentences or more: background, the task, and the format you want back. That length gap is exactly where voice prompting AI saves the most time.",
  },
  {
    title: "Natural speech produces more context",
    body: "When people type, they tend to compress and simplify. When people talk, they naturally add the context, examples, and caveats that make a prompt more effective, without consciously trying to.",
  },
  {
    title: "It fits how you already think through a problem",
    body: "Many people think out loud before they write. Voice prompting AI lets that first pass become the actual prompt, instead of an extra step before typing something shorter.",
  },
];

const WhyItWorksSection = () => {
  return (
    <section
      id="why-it-works"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2}>Why Voice Prompting AI Works Well With AI Chatbots</h2>

      <div className="mt-[30.05px] flex flex-col gap-[25.76px]">
        {REASONS.map(({ title, body }) => (
          <div key={title}>
            <h3 className={CARD_TITLE}>{title}</h3>
            <p className={`mt-[8px] ${BODY_SM}`}>{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyItWorksSection;
